const NetworkIcon = ({ className }) => {
	return (
		<svg
			className={className}
			viewBox="0 0 21 21"
			fill="currentColor"
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
		>
			<g transform="rotate(45, 12, 12)">
				<path d="M12 20.5C11.17 20.5 10.5 19.83 10.5 19C10.5 18.17 11.17 17.5 12 17.5C12.83 17.5 13.5 18.17 13.5 19C13.5 19.83 12.83 20.5 12 20.5ZM16.24 15.66C15.12 14.54 13.61 13.9 12 13.9C10.39 13.9 8.88 14.54 7.76 15.66L6.34 14.24C7.92 12.66 9.89 11.8 12 11.8C14.11 11.8 16.08 12.66 17.66 14.24L16.24 15.66ZM19.78 12.12C17.59 9.93 14.88 8.7 12 8.7C9.12 8.7 6.41 9.93 4.22 12.12L2.81 10.71C5.47 8.05 8.65 6.7 12 6.7C15.35 6.7 18.53 8.05 21.19 10.71L19.78 12.12Z" />
			</g>
		</svg>
	);
};

export default NetworkIcon;
